export interface DispatchLogHistoryDto {
  company: number | null;
  employeeLastName: string;
  employeeFirstName: string;
  shift: string;
  group: string;
  dept: string;
  craft: string;
  jobClass: string;
  otFactor: number | null;
  ptFactor: number | null;
  bPerDiemDocs: boolean | null;
  startDate: Date | null;
  rofDate: Date | null;
  mileage: number | null;
  mileageDesignation: string;
  bSigned: boolean | null;
  notes: string;
  perDiem: number | null;
  payRate: number | null;
  billPerDiem: number | null;
  dateModified: Date | null;
  modifiedBy: string;
  contractRate: number | null;
  fileOTFactor: number | null;
  filePTFactor: number | null;
  filePerDiem: number | null;
}
